/*
  21.10.2026 : lecteur des bulles de stories de la fiche produit (blocks/montrelio-stories.liquid).
  Délégation sur document : les bulles sont réinjectées par le morph au changement de variante.
  Tap à droite = suivante, à gauche = précédente, appui long = pause, glisser vers le bas ou Échap = fermer.
*/
(function () {
  var IMG_MS = 5200;
  var ov, st, bars, media, cap, title, atc, list = [], idx = 0, raf = 0, t0 = 0, paused = false, elapsed = 0, vid = null;

  function seenGet() { try { return JSON.parse(sessionStorage.getItem('mst-seen') || '{}'); } catch (e) { return {}; } }
  function seenSet(k) { try { var s = seenGet(); s[k] = 1; sessionStorage.setItem('mst-seen', JSON.stringify(s)); } catch (e) {} }
  function markSeen() {
    var s = seenGet();
    document.querySelectorAll('[data-mst-open]').forEach(function (b) { if (s[b.dataset.key]) b.classList.add('is-seen'); });
  }

  var CSS = ".mst-ov { position: fixed; inset: 0; z-index: 2147483000; background: rgba(10, 18, 14, .92); display: flex; align-items: center; justify-content: center; touch-action: none; }.mst-ov[hidden] { display: none; }.mst-st { position: relative; width: 100%; height: 100%; overflow: hidden; background: #0e1612; color: #fff; }@media (min-width: 750px) { .mst-st { width: auto; height: min(92vh, 860px); aspect-ratio: 9 / 16; border-radius: 14px; box-shadow: 0 20px 60px rgba(0,0,0,.45); } }.mst-bg { position: absolute; inset: -40px; background-size: cover; background-position: center; filter: blur(28px) brightness(.55); }.mst-m { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; overflow: hidden; }.mst-m video { width: 100%; height: auto; max-height: 100%; }.mst-img { position: absolute; inset: 0; background-size: cover; background-position: center; will-change: transform; }.mst-img--worn { animation: mst-worn 5.2s ease-in-out forwards; }.mst-img--dial { background-color: #fff; animation: mst-dial 5.2s ease-in-out forwards; }.mst-img--size { animation: mst-size 5.2s ease-out forwards; }@keyframes mst-worn { from { transform: scale(1.06) translateX(-3%) rotate(-1.2deg); } to { transform: scale(1.2) translateX(3%) rotate(1.2deg); } }@keyframes mst-dial { from { transform: scale(1); } to { transform: scale(1.55); } }@keyframes mst-size { from { transform: scale(1.12); } to { transform: scale(1); } }.mst-glint { position: absolute; inset: 0; pointer-events: none; background: linear-gradient(115deg, transparent 40%, rgba(255,255,255,.55) 50%, transparent 60%); transform: translateX(-120%); animation: mst-glint 2.4s 1.4s ease-in-out forwards; mix-blend-mode: soft-light; }@keyframes mst-glint { to { transform: translateX(120%); } }.mst-st::after { content: \"\"; position: absolute; left: 0; right: 0; top: 0; height: 120px; z-index: 2; pointer-events: none; background: linear-gradient(rgba(0,0,0,.45), transparent); }.mst-bars { position: absolute; top: 10px; left: 10px; right: 10px; display: flex; gap: 4px; z-index: 3; }.mst-bars i { flex: 1; height: 2.5px; border-radius: 2px; background: rgba(255,255,255,.35); overflow: hidden; }.mst-bars i b { display: block; height: 100%; width: 0; background: #fff; }.mst-hd { position: absolute; top: 22px; left: 14px; right: 8px; display: flex; align-items: center; justify-content: space-between; z-index: 3; text-shadow: 0 1px 6px rgba(0,0,0,.5); }.mst-hd span { font-family: var(--font-body--family, sans-serif); font-weight: 600; font-size: .9rem; }.mst-x:focus { outline: none; }.mst-x:focus-visible { outline: 2px solid #d9b96a; border-radius: 50%; }.mst-x { background: none; border: 0; color: #fff; width: 40px; height: 40px; font-size: 28px; line-height: 1; cursor: pointer; }.mst-tap { position: absolute; top: 70px; bottom: 110px; z-index: 2; background: none; border: 0; padding: 0; cursor: pointer; }.mst-tap--p { left: 0; width: 33%; }.mst-tap--n { right: 0; width: 67%; }.mst-cap { position: absolute; left: 16px; right: 16px; bottom: 96px; z-index: 3; background: rgba(253,250,242,.94); color: #1c3a2e; border-radius: 10px; padding: 12px 14px; font-family: var(--font-body--family, sans-serif); font-size: .92rem; line-height: 1.4; box-shadow: 0 6px 20px rgba(0,0,0,.25); }.mst-cap:empty { display: none; }.mst-ft { position: absolute; left: 16px; right: 16px; bottom: max(18px, env(safe-area-inset-bottom)); z-index: 3; }.mst-atc { width: 100%; min-height: 52px; border: 0; border-radius: 8px; background: #c7a24e; color: #142b22; font-family: var(--font-body--family, sans-serif); font-weight: 700; font-size: 14.5px; letter-spacing: .58px; text-transform: uppercase; cursor: pointer; }";

  function build() {
    if (!document.getElementById('mst-css')) { var sc = document.createElement('style'); sc.id = 'mst-css'; sc.textContent = CSS; document.head.appendChild(sc); }
    ov = document.createElement('div');
    ov.className = 'mst-ov'; ov.hidden = true;
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Stories de la montre');
    ov.innerHTML =
      '<div class="mst-st"><div class="mst-bg"></div><div class="mst-m"></div><div class="mst-bars"></div>' +
      '<div class="mst-hd"><span></span><button type="button" class="mst-x" aria-label="Fermer">×</button></div>' +
      '<button type="button" class="mst-tap mst-tap--p" aria-label="Story précédente"></button>' +
      '<button type="button" class="mst-tap mst-tap--n" aria-label="Story suivante"></button>' +
      '<div class="mst-cap"></div><div class="mst-ft"><button type="button" class="mst-atc">Ajouter au panier</button></div></div>';
    document.body.appendChild(ov);
    st = ov.querySelector('.mst-st'); bars = ov.querySelector('.mst-bars'); media = ov.querySelector('.mst-m');
    cap = ov.querySelector('.mst-cap'); title = ov.querySelector('.mst-hd span'); atc = ov.querySelector('.mst-atc');

    ov.querySelector('.mst-x').addEventListener('click', close);
    ov.querySelector('.mst-tap--p').addEventListener('click', function () { if (!held) go(idx - 1); });
    ov.querySelector('.mst-tap--n').addEventListener('click', function () { if (!held) go(idx + 1); });
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    atc.addEventListener('click', function () {
      var b = document.querySelector('.product-details button[name="add"], button[name="add"][ref="addToCartButton"]');
      close();
      if (b && !b.disabled) b.click();
    });

    var held = false, holdT = 0, y0 = null;
    st.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.mst-x, .mst-atc')) return;
      y0 = e.clientY; held = false;
      holdT = setTimeout(function () { held = true; pause(true); }, 220);
    });
    st.addEventListener('pointerup', function (e) {
      clearTimeout(holdT);
      if (y0 !== null && e.clientY - y0 > 90) { y0 = null; close(); return; }
      y0 = null;
      if (held) { pause(false); setTimeout(function () { held = false; }, 0); }
    });
    st.addEventListener('pointercancel', function () { clearTimeout(holdT); if (held) pause(false); held = false; y0 = null; });
    document.addEventListener('keydown', function (e) {
      if (ov.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') go(idx + 1);
      else if (e.key === 'ArrowLeft') go(idx - 1);
    });
  }

  function pause(on) {
    paused = on;
    if (vid) { on ? vid.pause() : vid.play().catch(function () {}); }
    media.querySelectorAll('.mst-img, .mst-glint').forEach(function (el) { el.style.animationPlayState = on ? 'paused' : 'running'; });
    if (!on) t0 = performance.now() - elapsed;
  }

  function setBar(i, ratio) {
    var b = bars.children[i] && bars.children[i].firstChild;
    if (b) b.style.width = Math.max(0, Math.min(1, ratio)) * 100 + '%';
  }

  function tick(now) {
    if (!paused) {
      var r;
      if (vid) r = vid.duration ? vid.currentTime / vid.duration : 0;
      else { elapsed = now - t0; r = elapsed / IMG_MS; }
      setBar(idx, r);
      if (!vid && r >= 1) { go(idx + 1); return; }
    }
    raf = requestAnimationFrame(tick);
  }

  function show(i) {
    cancelAnimationFrame(raf);
    if (vid) { vid.pause(); vid.removeAttribute('src'); vid.load(); vid = null; }
    idx = i; paused = false; elapsed = 0;
    for (var k = 0; k < list.length; k++) setBar(k, k < i ? 1 : 0);
    var d = list[i].dataset;
    title.textContent = d.title || '';
    cap.innerHTML = d.caption || '';
    media.innerHTML = '';
    ov.querySelector('.mst-bg').style.backgroundImage = 'url("' + (d.poster || d.src) + '")';
    if (d.kind === 'video') {
      vid = document.createElement('video');
      vid.muted = true; vid.playsInline = true; vid.setAttribute('playsinline', ''); vid.autoplay = true; vid.preload = 'auto';
      if (d.poster) vid.poster = d.poster;
      vid.src = d.src;
      vid.addEventListener('ended', function () { go(idx + 1); });
      media.appendChild(vid);
      vid.play().catch(function () {});
    } else {
      var im = document.createElement('div');
      im.className = 'mst-img mst-img--' + (d.anim || 'worn');
      im.style.backgroundImage = 'url("' + d.src + '")';
      media.appendChild(im);
      if (d.anim === 'dial') { var g = document.createElement('div'); g.className = 'mst-glint'; media.appendChild(g); }
    }
    seenSet(d.key);
    t0 = performance.now();
    raf = requestAnimationFrame(tick);
  }

  function go(i) {
    if (i < 0) i = 0;
    if (i >= list.length) { close(); return; }
    show(i);
  }

  function open(btn) {
    if (!ov) build();
    document.querySelectorAll('.mbb-ribbon__tipvid').forEach(function (v) { v.pause(); });
    var row = btn.closest('[data-mst]');
    list = row ? Array.prototype.slice.call(row.querySelectorAll('[data-mst-open]')) : [];
    if (list.indexOf(btn) < 0) list = [btn];
    bars.innerHTML = list.map(function () { return '<i><b></b></i>'; }).join('');
    var main = document.querySelector('.product-details button[name="add"], button[name="add"][ref="addToCartButton"]');
    atc.textContent = main ? (main.innerText || main.textContent || '').replace(/\s+/g, ' ').replace(/\s*\|\s*/, ' | ').trim() || 'Ajouter au panier' : 'Ajouter au panier';
    atc.hidden = !!(main && main.disabled);
    ov.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    show(list.indexOf(btn));
    ov.querySelector('.mst-x').focus({ preventScroll: true });
    if (window.gtag) window.gtag('event', 'product_story_open', { story: btn.dataset.key });
  }

  function close() {
    if (!ov || ov.hidden) return;
    cancelAnimationFrame(raf);
    if (vid) { vid.pause(); vid = null; }
    media.innerHTML = '';
    ov.hidden = true;
    document.documentElement.style.overflow = '';
    markSeen();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mst-open]');
    if (b) { e.preventDefault(); open(b); }
  });

  // Déclencheur qui n'est pas un <button> (ruban écrin ordinateur) : Entrée ou Espace l'ouvre aussi.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target.closest && e.target.closest('[data-mst-open]');
    if (b && b.tagName !== 'BUTTON' && e.target === b) { e.preventDefault(); open(b); }
  });

  // Ruban écrin (ordinateur) : la vidéo de la bulle au survol ne joue que pendant le survol.
  function tipVid(rib) { return rib && rib.querySelector('.mbb-ribbon__tipvid'); }
  document.addEventListener('mouseover', function (e) {
    var rib = e.target.closest && e.target.closest('.mbb-ribbon--story');
    var v = tipVid(rib);
    if (v && v.paused) v.play().catch(function () {});
  });
  document.addEventListener('mouseout', function (e) {
    var rib = e.target.closest && e.target.closest('.mbb-ribbon--story');
    if (!rib || (e.relatedTarget && rib.contains(e.relatedTarget))) return;
    var v = tipVid(rib);
    if (v) v.pause();
  });

  function init() { markSeen(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  new MutationObserver(function () { clearTimeout(init.t); init.t = setTimeout(markSeen, 150); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
